import { Base } from '@studiometa/js-toolkit';

/**
 * PageTransitionLink
 */
export default class PageTransitionLink extends Base {
  static config = {
    name: 'PageTransitionLink',
    options: {
      back: Boolean,
    },
  };

  /**
   * On click
   * @param {MouseEvent} event
   */
  onClick(event) {
    event.preventDefault();
    if (this.$options.back) {
      this.$parent.goTo(this.$parent.lastUrl ?? this.$el.href);
      return;
    }
    this.$parent.goTo(this.$el.href);
  }
}
